import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SchoolNotification } from '@core/services/notification.service';

/** One row of the notification list, used by the toolbar bell and the Notifications page. */
@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  standalone: false,
})
export class NotificationItemComponent {
  @Input({ required: true }) notification!: SchoolNotification;
  @Output() open = new EventEmitter<SchoolNotification>();

  get icon(): string {
    switch (this.notification.kind) {
      case 'PUPIL_LINK_REQUEST':
        return 'person_add';
      case 'ACCOUNT_DEACTIVATION_REQUEST':
        return 'person_remove';
      case 'MIS_SYNC_FINISHED':
        return 'sync';
      default:
        return 'event_busy';
    }
  }
}
